import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _JSON$stringify from '/app/node_modules/babel-runtime/core-js/json/stringify';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import alertModal from './alert-modal';
import { WarningError } from "~/abstractions/errors";
import { onlyEmail, onlyLetters, noSpecialChars } from '~/validators';
import { emailErrorMessagesMixin, onlyNumbersMixin, onlyLettersMixin } from '~/mixins';
import { required, email, numeric, minLength } from 'vuelidate/lib/validators';
import { ConflictError, BadRequestError } from '~/abstractions/errors';
import { mapState, mapActions } from 'vuex';
import { RoleEnum } from '@affiliation/enums';

export default {
    props: ['idTeamData'],
    components: {
        alertModal: alertModal
    },
    mixins: [emailErrorMessagesMixin, onlyNumbersMixin, onlyLettersMixin],
    data: function data() {
        var _$store$state$team$re = this.$store.state.team.responseSeller,
            documentNumber = _$store$state$team$re.documentNumber,
            email = _$store$state$team$re.email,
            firstname = _$store$state$team$re.firstname,
            idDocumentType = _$store$state$team$re.idDocumentType,
            idRoles = _$store$state$team$re.idRoles,
            isActive = _$store$state$team$re.isActive,
            lastname = _$store$state$team$re.lastname,
            idUser = _$store$state$team$re.idUser,
            cellphone = _$store$state$team$re.cellphone,
            channelCode = _$store$state$team$re.channelCode,
            channelName = _$store$state$team$re.channelName,
            subChannelCode = _$store$state$team$re.subChannelCode,
            subChannelName = _$store$state$team$re.subChannelName,
            groupChannelCode = _$store$state$team$re.groupChannelCode,
            groupChannelName = _$store$state$team$re.groupChannelName,
            idUserCategory = _$store$state$team$re.idUserCategory;
        var _$store$state$master = this.$store.state['master-data'],
            documentTypesCollaboratorsPage = _$store$state$master.documentTypesCollaboratorsPage,
            userCategories = _$store$state$master.userCategories;

        var isSupervisorResponse = idRoles[0] == 4 ? false : true;
        var title = firstname + ' ' + lastname;
        return {
            documentTypesCollaboratorsPage: documentTypesCollaboratorsPage,
            userCategories: userCategories,
            editFormSeller: true,
            sellerName: firstname,
            sellerLastName: lastname,
            docNumber: documentNumber,
            email: email,
            multipleOptions: true,
            checkbox: isSupervisorResponse || '',
            switchState: isActive,
            isSupervisorConditional: isSupervisorResponse,
            conditionalShowMessageSupervisor: false,
            conditionalShowMessageStatus: false,
            titlePrincipal: title,
            sending: false,
            docType: idDocumentType,
            maxLengthDocumentNumber: 8,
            message: '',
            idSeller: idUser,
            resultValidEmailService: false,
            resultValidDocumentService: false,
            timeout: null,
            messageDocumentNumber: '',
            validSellerEmail: false,
            teamStatus: '',
            cellphone: cellphone,
            userCategory: idUserCategory,
            channel: channelCode ? { value: channelCode, text: channelName } : null,
            subChannel: subChannelCode ? { value: subChannelCode, text: subChannelName } : null,
            groupChannel: groupChannelCode ? { value: groupChannelCode, text: groupChannelName } : null,
            channels: [],
            subChannels: [],
            groupChannels: [],
            loadingSubChannels: false,
            loadingGroupChannels: false
        };
    },
    validations: function validations() {
        return {
            sellerName: {
                required: required,
                onlyLetters: onlyLetters('sellerName')
            },
            sellerLastName: {
                required: required,
                onlyLetters: onlyLetters('sellerLastName')
            },
            docType: { required: required },
            docNumber: {
                required: required,
                numeric: numeric,
                minLength: minLength(this.maxLengthDocumentNumber)
                //validSellerDocument: this.validDocument
            },
            email: {
                required: required,
                // email,
                noSpecialChars: noSpecialChars('noSpecialChars'),
                emailValidate: onlyEmail('emailValidate')
                //validSellerEmail: this.validEmail
            }
        };
    },

    methods: _extends({}, mapActions({
        consultSubChannel: 'affiliations/form/consultSubChannel',
        consultGroupChannel: 'affiliations/form/consultGroupChannel'
    }), {
        validateDocNumber: function validateDocNumber() {
            var _this = this;

            if (this.docNumber === '') return true;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _this.$store.dispatch('team/validationDocumentNumberSeller', {
                                    idUser: _this.idSeller,
                                    documentNumber: _this.docNumber
                                });

                            case 3:
                                _this.resultValidDocumentService = true;
                                _context.next = 10;
                                break;

                            case 6:
                                _context.prev = 6;
                                _context.t0 = _context['catch'](0);

                                if (_context.t0 instanceof ConflictError) {
                                    _this.messageDocumentNumber = _context.t0.message;
                                } else {
                                    _this.messageDocumentNumber = _JSON$stringify(_context.t0.data.constraints[0].constraints.isEmail);
                                }
                                _this.resultValidDocumentService = false;

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 6]]);
            })), 500);
        },
        validateEmail: function validateEmail() {
            var _this2 = this;

            if (this.email === '') return true;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return _this2.$store.dispatch('team/validSellersEmail', {
                                    idUser: _this2.idSeller,
                                    email: _this2.email
                                });

                            case 3:
                                _this2.resultValidEmailService = true;
                                _context2.next = 10;
                                break;

                            case 6:
                                _context2.prev = 6;
                                _context2.t0 = _context2['catch'](0);

                                _this2.resultValidEmailService = false;
                                if (_context2.t0 instanceof ConflictError) {
                                    _this2.message = _context2.t0.message;
                                } else {
                                    _this2.message = _JSON$stringify(_context2.t0.data.constraints[0].constraints.isEmail);
                                }

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[0, 6]]);
            })), 500);
        },
        prevPage: function prevPage() {
            if (this.$isSupervisor()) {
                this.$router.push('/my-team');
            } else if (this.$isBoss()) {
                this.$router.push('/channels/teams/' + this.idTeamData);
            } else if (this.$isAdmin() || this.$isAdminCollaborator()) {
                this.$router.push('/bosses/channel/' + this.idTeamData);
            }
        },
        openEdit: function openEdit() {
            // console.log('openEdit')
        },
        onSubmit: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var timestamp, _ref4, existeCorreo, responseServer, isSupervisorConditional, conditionalRole;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.$v.$touch();
                                this.sending = true;

                                _context3.prev = 2;

                                // servicio verificar correo
                                timestamp = Date.now();
                                _context3.next = 6;
                                return this.$store.dispatch("affiliations/form/getVerifiedEmail", {
                                    transaccionId: timestamp,
                                    correo: this.email.toLowerCase()
                                });

                            case 6:
                                _ref4 = _context3.sent;
                                existeCorreo = _ref4.existeCorreo;
                                responseServer = _ref4.responseServer;

                                if (!(responseServer === 'Error')) {
                                    _context3.next = 14;
                                    break;
                                }

                                this.$swal('Error', 'Error en el servicio. Vuelva a intentarlo mas tarde.', 'error');
                                this.sending = false;
                                _context3.next = 38;
                                break;

                            case 14:
                                if (!existeCorreo) {
                                    _context3.next = 36;
                                    break;
                                }

                                _context3.prev = 15;
                                isSupervisorConditional = this.checkbox == true ? RoleEnum.SUPERVISOR : RoleEnum.SELLER;
                                conditionalRole = this.$store.state.team.responseSeller;

                                if (!(conditionalRole.idRoles[0] == RoleEnum.SUPERVISOR)) {
                                    _context3.next = 23;
                                    break;
                                }

                                _context3.next = 21;
                                return this.$store.dispatch('team/editSupervisor', {
                                    idDocumentType: this.docType,
                                    documentNumber: this.docNumber,
                                    firstName: this.sellerName,
                                    lastName: this.sellerLastName,
                                    email: this.email,
                                    isActive: this.switchState,
                                    idRole: isSupervisorConditional,
                                    cellphone: this.cellphone,
                                    channelCode: this.channel && this.channel.value,
                                    channelName: this.channel && this.channel.text,
                                    subChannelCode: this.subChannel && this.subChannel.value,
                                    subChannelName: this.subChannel && this.subChannel.text,
                                    groupChannelCode: this.groupChannel && this.groupChannel.value,
                                    groupChannelName: this.groupChannel && this.groupChannel.text,
                                    idUserCategory: this.userCategory
                                });

                            case 21:
                                _context3.next = 25;
                                break;

                            case 23:
                                _context3.next = 25;
                                return this.$store.dispatch('team/editSeller', {
                                    idDocumentType: this.docType,
                                    documentNumber: this.docNumber,
                                    firstName: this.sellerName,
                                    lastName: this.sellerLastName,
                                    email: this.email,
                                    isActive: this.switchState,
                                    idRole: isSupervisorConditional,
                                    cellphone: this.cellphone,
                                    channelCode: this.channel && this.channel.value,
                                    channelName: this.channel && this.channel.text,
                                    subChannelCode: this.subChannel && this.subChannel.value,
                                    subChannelName: this.subChannel && this.subChannel.text,
                                    groupChannelCode: this.groupChannel && this.groupChannel.value,
                                    groupChannelName: this.groupChannel && this.groupChannel.text,
                                    idUserCategory: this.userCategory
                                });

                            case 25:

                                this.$refs.alertModal.EditSuccessful();

                                _context3.next = 31;
                                break;

                            case 28:
                                _context3.prev = 28;
                                _context3.t0 = _context3['catch'](15);

                                if (_context3.t0 instanceof ConflictError) {
                                    this.$swal('Error', _context3.t0.message, 'warning');
                                } else if (_context3.t0 instanceof BadRequestError) {
                                    console.log(_context3.t0);
                                    this.$swal('Error', _context3.t0.message, 'warning');
                                } else {
                                    this.$controlMessage(_context3.t0);
                                }

                            case 31:
                                this.$emit("completeForm");
                                this.dialog = false;
                                this.sending = false;
                                _context3.next = 38;
                                break;

                            case 36:
                                this.$swal('Aviso', 'No existe el correo ' + this.email + ', ingresar uno correcto.', 'warning');
                                this.sending = false;

                            case 38:
                                _context3.next = 44;
                                break;

                            case 40:
                                _context3.prev = 40;
                                _context3.t1 = _context3['catch'](2);

                                this.$swal('Aviso', 'El correo ingresado tiene formato incorrecto.', 'warning');
                                this.sending = false;

                            case 44:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[2, 40], [15, 28]]);
            }));

            function onSubmit() {
                return _ref3.apply(this, arguments);
            }

            return onSubmit;
        }(),
        changeEvent: function changeEvent(val) {
            // console.log('change')
            switch (val) {
                case 1:
                    this.maxLengthDocumentNumber = 8, this.validationDocument = val;
                    this.docNumber = "";
                    break;
                case 2:
                    this.maxLengthDocumentNumber = 12, this.validationDocument = val;
                    this.docNumber = "";
                    break;
                case 4:
                    this.maxLengthDocumentNumber = 12, this.validationDocument = val;
                    this.docNumber = "";
                    break;
                default:
                    this.maxLengthDocumentNumber = 8;break;
            }
        }
    }),
    computed: _extends({}, mapState({
        //isSupervisor
        dataSeller: function dataSeller(state) {
            return state.team.responseSeller;
        },
        nameTeam: function nameTeam(state) {
            return state.team.nameTeam;
        }

    }), {
        disabled: function disabled() {
            return this.loadingSubChannels || this.loadingGroupChannels || this.sending || this.$v.$invalid || !this.resultValidDocumentService || !this.resultValidEmailService;
        },
        canEditState: function canEditState() {
            return this.$isSupervisor ? false : true;
        },
        sellerNameErrorMessages: function sellerNameErrorMessages() {
            var errors = [];
            if (!this.$v.sellerName.$dirty) return errors;
            !this.$v.sellerName.required && errors.push('Campo obligatorio');
            !this.$v.sellerName.onlyLetters && errors.push('Ingrese sólo letras');
            return errors;
        },
        sellerLastNameErrorMessages: function sellerLastNameErrorMessages() {
            var errors = [];
            if (!this.$v.sellerLastName.$dirty) return errors;
            !this.$v.sellerLastName.required && errors.push('Campo obligatorio');
            !this.$v.sellerLastName.onlyLetters && errors.push('Ingrese sólo letras');
            return errors;
        },
        docNumberErrorMessages: function docNumberErrorMessages() {
            var errors = [];
            if (!this.$v.docNumber.$dirty) return errors;
            !this.$v.docNumber.required && errors.push('Campo obligatorio'), !this.$v.docNumber.minLength && errors.push('Debes ingresar m\xEDnimo ' + this.maxLengthDocumentNumber + ' n\xFAmeros'), !this.$v.docNumber.numeric && errors.push('Ingresa sólo números'), !this.resultValidDocumentService && errors.push(this.messageDocumentNumber);
            return errors;
        },
        emailErrorMessagesByConsult: function emailErrorMessagesByConsult() {
            var errors = [];
            if (!this.$v.email.$dirty) return errors;
            !this.$v.email.required && errors.push('Campo obligatorio'),
            // !this.$v.email.email && errors.push('Correo inválido'),
            !this.$v.email.noSpecialChars && errors.push('No puede ingresar caracteres espciales'), !this.$v.email.emailValidate && errors.push('Ingrese un email válido'), !this.resultValidEmailService && errors.push(this.message);
            return errors;
        }
    }),
    watch: {
        isSupervisorConditional: function isSupervisorConditional(val) {
            if (val == true) {
                this.conditionalShowMessageSupervisor = false;
            }
        },
        checkbox: function checkbox(val) {
            if (val == true) {
                this.switchState = true;
                this.conditionalShowMessageSupervisor = true;
            } else {
                this.conditionalShowMessageSupervisor = false;
            }
        },
        switchState: function switchState(val) {
            if (val == false) {
                this.checkbox = false;
                this.sending = false;
                this.conditionalShowMessageStatus = true;
            } else if (val == true) {
                this.conditionalShowMessageStatus = false;
            } else if (val == false && this.checkbox == true) {
                this.sending = true;
            } else if (val == false && this.checkbox == false) {
                this.sending = false;
            } else {
                this.sending = false;
            }
        },
        channel: function channel(newVal, oldVal) {
            if (oldVal) this.$nextTick(function () {
                this.subChannel = null;
            });

            if (!newVal) return;

            this.$nextTick(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;

                                this.loadingSubChannels = true;
                                _context4.next = 4;
                                return this.consultSubChannel(newVal.value);

                            case 4:
                                this.subChannels = _context4.sent;
                                _context4.next = 10;
                                break;

                            case 7:
                                _context4.prev = 7;
                                _context4.t0 = _context4['catch'](0);

                                this.$controlMessage(_context4.t0);

                            case 10:
                                _context4.prev = 10;

                                this.loadingSubChannels = false;
                                return _context4.finish(10);

                            case 13:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[0, 7, 10, 13]]);
            })));
        },
        subChannel: function subChannel(newVal, oldVal) {
            if (oldVal) this.$nextTick(function () {
                this.groupChannel = null;
            });

            if (!newVal) return;

            this.$nextTick(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.prev = 0;

                                this.loadingGroupChannels = true;
                                _context5.next = 4;
                                return this.consultGroupChannel(newVal.value);

                            case 4:
                                this.groupChannels = _context5.sent;
                                _context5.next = 10;
                                break;

                            case 7:
                                _context5.prev = 7;
                                _context5.t0 = _context5['catch'](0);

                                this.$controlMessage(_context5.t0);

                            case 10:
                                _context5.prev = 10;

                                this.loadingGroupChannels = false;
                                return _context5.finish(10);

                            case 13:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[0, 7, 10, 13]]);
            })));
        }
    },
    mounted: function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            var _this3 = this;

            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            this.resultValidDocumentService = true;
                            this.resultValidEmailService = true;
                            this.teamStatus = this.$route.query.teamStatus;

                            _context6.prev = 3;

                            this.loadingSubChannels = true;
                            this.loadingGroupChannels = true;

                            _context6.next = 8;
                            return _Promise.all([this.$store.dispatch('affiliations/form/consultChannel').then(function (channels) {
                                return _this3.channels = channels;
                            }), this.channel ? this.consultSubChannel(this.channel.value).then(function (subChannels) {
                                return _this3.subChannels = subChannels;
                            }) : _Promise.resolve(), this.subChannel ? this.consultGroupChannel(this.subChannel.value).then(function (groupChannels) {
                                return _this3.groupChannels = groupChannels;
                            }) : _Promise.resolve()]);

                        case 8:
                            _context6.next = 13;
                            break;

                        case 10:
                            _context6.prev = 10;
                            _context6.t0 = _context6['catch'](3);

                            this.$controlMessage(_context6.t0);

                        case 13:
                            _context6.prev = 13;

                            this.loadingSubChannels = false;
                            this.loadingGroupChannels = false;
                            return _context6.finish(13);

                        case 17:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[3, 10, 13, 17]]);
        }));

        function mounted() {
            return _ref7.apply(this, arguments);
        }

        return mounted;
    }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/seller-detail.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/seller-detail.vue
// module chunks = 7 10 11 12